import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { DatePicker } from "antd";
import moment, { Moment } from "moment";
import {
    ChangeEvent,
    Dispatch,
    SetStateAction,
    useEffect,
    useRef,
    useState,
} from "react";
import { useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import {
    AtualizacaoCadastroDeDirecionamentoController,
    CadastroDeDirecionamentoController,
    ListarClassesControlesDirecionamentoController,
    getCadastroDeDirecionamentoController,
} from "../../../../Controllers/AssistenciaTecnica/CadastroDeDirecionamento/CadastroDeDirecionamento";
import { ListarEmpreendimentosController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import {
    ICadastroDeDirecionamento,
    ICadastroDeDirecionamentoResponse,
} from "../../../../Interfaces/AssistenciaTecnica/CadastroDeDirecionamento/CadastroDeDirecionamentoInterface";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import { MoneyReaisFieldMask } from "../../../../Validations/InputMasks";
import SeletorCategoriaAtendimento from "../../../../Components/CardsPages/Forms/SelectCategoriaAtendimento";
import Select from "react-select";

interface ICreateUpdateDirecionamento {
    row?: ICadastroDeDirecionamento;
    setShow: Dispatch<SetStateAction<boolean>>;
    ListagemCadastroDeDirecionamento: (
        ...args: any[]
    ) => Promise<ICadastroDeDirecionamentoResponse>;

    setDsEmpreendimento: Dispatch<SetStateAction<string | undefined>>;
    dsEmpreendimento: string | undefined;
}

export default function CreateUpdateDirecionamento(
    props: ICreateUpdateDirecionamento
) {
    const formMethods = useForm<ICadastroDeDirecionamento>();

    const { id } = useModuloInfo();

    const selectInputRef = useRef<any>();

    const [selectedOption, setSelectedOption] = useState({
        label: "",
        value: 0,
    });

    const { control } = formMethods;

    const {
        execute: CadastroDeDirecionamento,
        loading: CadastroDeDirecionamentoLoading,
    } = useAsyncCallback(CadastroDeDirecionamentoController);

    const {
        execute: AtualizacaoCadastroDeDirecionamento,
        loading: AtualizacaoCadastroDeDirecionamentoLoading,
    } = useAsyncCallback(AtualizacaoCadastroDeDirecionamentoController);

    const {
        value: getCadastroDeDirecionamento,
        loading: getCadastroDeDirecionamentoLoading,
    } = useAsyncEffect(async () => {
        if (props.row) {
            const res = await getCadastroDeDirecionamentoController(
                props.row.ID
            );
            return res;
        }
    }, [props.row]);
    const [idCategoriaPai, setIdCategoriaPai] = useState<number>(
        getCadastroDeDirecionamento?.ID_SUBASSUNTO ?? 0
    );

    const { value: lstEmpreendimentos, loading: lstEmpreendimentosLoading } =
        useAsyncEffect(() => ListarEmpreendimentosController(), []);

    function geradorMascaraFinanceira(
        inputName: keyof ICadastroDeDirecionamento
    ) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            const mask = MoneyReaisFieldMask(e);
            formMethods?.setValue(inputName, mask);
        };
    }

    function formatadorDatas(inputName: keyof ICadastroDeDirecionamento) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            let data: string | string[] = e.target.value;

            if (data.length !== 10) {
                let nvDate: string | string[] = data.split("-");
                nvDate[0] = nvDate[0].substring(1, 5);
                nvDate = nvDate.join("-");
                data = nvDate;
            }

            formMethods?.setValue(inputName, moment(data).format("YYYY-MM-DD"));
        };
    }

    const [ano, setAno] = useState<string>(
        String(getCadastroDeDirecionamento?.ANO ?? "")
    );

    function onChangeAno(date: Moment | null, dateString: string) {
        setAno(dateString);
    }

    const [mes, setMes] = useState<string>(
        String(getCadastroDeDirecionamento?.MES ?? "")
    );

    function onChangeMes(date: Moment | null, dateString: string) {
        setMes(dateString);
    }

    function handleCreateUpdatePrevisto(formData: ICadastroDeDirecionamento) {
        if (props.row) {
            AtualizacaoCadastroDeDirecionamento([
                {
                    ...formData,
                    ID: props.row.ID,
                    MES: mes ? mes : getCadastroDeDirecionamento?.MES ?? "",
                    ANO: ano ? ano : getCadastroDeDirecionamento?.ANO ?? "",
                    ID_SUBASSUNTO: idCategoriaPai
                        ? idCategoriaPai
                        : getCadastroDeDirecionamento?.ID_SUBASSUNTO ?? 0,
                    ID_RESIDENCIAL: selectedOption.value,
                },
            ]).then(() => {
                props.setDsEmpreendimento("");
                props.setShow(false);
                props.ListagemCadastroDeDirecionamento();
            });
        } else {
            CadastroDeDirecionamento({
                ...formData,
                MES: mes ? mes : getCadastroDeDirecionamento?.MES ?? "",
                ANO: ano ? ano : getCadastroDeDirecionamento?.ANO ?? "",
                ID_SUBASSUNTO: idCategoriaPai,
                ID_RESIDENCIAL: selectedOption.value,
            }).then(() => {
                props.setDsEmpreendimento("");
                props.setShow(false);
                props.ListagemCadastroDeDirecionamento();
            });
        }
    }

    const isLoading =
        CadastroDeDirecionamentoLoading ||
        AtualizacaoCadastroDeDirecionamentoLoading;

    const [options, setOptions] = useState<
        Array<{ value: number; label: string }> | undefined
    >();

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    useEffect(() => {
        setOptions(() =>
            lstEmpreendimentos
                ?.filter((lst) => lst.DS_ESTADO !== null)
                ?.map((empreendimento) => ({
                    label: empreendimento.DS_EMPREENDIMENTO,
                    value: empreendimento.ID_EMPREENDIMENTO,
                }))
        );
        if (getCadastroDeDirecionamento) {
            setSelectedOption({
                label: getCadastroDeDirecionamento.DS_RESIDENCIAL,
                value: getCadastroDeDirecionamento.ID_RESIDENCIAL,
            });
        }
    }, [
        getCadastroDeDirecionamento,
        getCadastroDeDirecionamento?.ID_RESIDENCIAL,
        lstEmpreendimentos,
    ]);

    return (
        <OrSpinner
            loading={
                getCadastroDeDirecionamentoLoading || lstEmpreendimentosLoading
            }
            spinner="capys"
        >
            <UnForm handleSubmit={handleCreateUpdatePrevisto}>
                <div className="row">
                    <div className="col-md-6">
                        <label>Classificação / Sub-Assunto</label>
                        <SeletorCategoriaAtendimento
                            showPlaceholder
                            ID_MODULO={id}
                            setIdCategoria={(c) =>
                                setIdCategoriaPai(c as number)
                            }
                            filterTreeNode={(input, treeNode) =>
                                treeNode?.props.title
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                            }
                            showSearch
                            control={control}
                            name="ID_SUBASSUNTO"
                            defaultValue={
                                getCadastroDeDirecionamento?.ID_SUBASSUNTO
                            }
                        />
                    </div>

                    <div className="col-md-6">
                        <UnForm.LazySelect
                            label="Classe Controle Direcionamento"
                            name="ID_CLASSE_CONTROLE_DIRECIONAMENTO"
                            controller={
                                ListarClassesControlesDirecionamentoController
                            }
                            getDS={(ds) => ds.DS_CLASSE_CONTROLE_DIRECIONAMENTO}
                            getKeyValue={(key) =>
                                key.ID_CLASSE_CONTROLE_DIRECIONAMENTO
                            }
                            defaultValue={
                                getCadastroDeDirecionamento?.ID_CLASSE_CONTROLE_DIRECIONAMENTO
                            }
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>

                    <div className="col-md-6">
                        <label>Residencial</label>
                        <Select
                            name="ID_RESIDENCIAL"
                            ref={selectInputRef}
                            options={options}
                            isClearable
                            value={selectedOption}
                            onChange={(e) => {
                                const selectedValue = e
                                    ? e.label.toString()
                                    : "";
                                props.setDsEmpreendimento(selectedValue);
                                setSelectedOption({
                                    label: e?.label ? e.label : "",
                                    value: e?.value ? e.value : 0,
                                });
                            }}
                            components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                            }}
                            styles={customStyles}
                            placeholder=""
                            noOptionsMessage={() => "Nenhuma opção"}
                        />
                    </div>

                    <div className="col-md-6">
                        <UnForm.Input
                            label="Valor total"
                            name="VL_VALOR"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    return Number(
                                        MoneyReaisFieldMask.unMask(v)
                                    );
                                },
                                required: "Insira um valor",
                            }}
                            onChange={geradorMascaraFinanceira("VL_VALOR")}
                            defaultValue={formatMoneyReais(
                                getCadastroDeDirecionamento?.VL_VALOR ?? 0
                            )}
                        />
                    </div>
                    <div className="col-md-6">
                        <UnForm.Input
                            className="mb-4"
                            label="Data"
                            name="DATA"
                            onChange={formatadorDatas("DATA")}
                            defaultValue={
                                getCadastroDeDirecionamento?.DATA
                                    ? new Date(
                                          getCadastroDeDirecionamento?.DATA
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            type="date"
                            registerOptions={{
                                required: "Insira uma data",
                            }}
                        ></UnForm.Input>
                    </div>
                    <div className="col-md-6">
                        <label>Mês</label>
                        <DatePicker
                            picker="month"
                            onChange={onChangeMes}
                            className="form-control"
                            defaultValue={
                                getCadastroDeDirecionamento?.MES
                                    ? moment(
                                          getCadastroDeDirecionamento?.MES.toString(),
                                          "MM"
                                      )
                                    : undefined
                            }
                            placeholder=""
                            format={"MM"}
                        />
                    </div>

                    <div className="col-md-6">
                        <label>Ano</label>
                        <DatePicker
                            picker="year"
                            onChange={onChangeAno}
                            className="form-control"
                            defaultValue={
                                getCadastroDeDirecionamento?.ANO
                                    ? moment(
                                          getCadastroDeDirecionamento?.ANO.toString(),
                                          "YYYY"
                                      )
                                    : undefined
                            }
                            placeholder=""
                        />
                    </div>
                    <div className="col-md-12">
                        <UnForm.SubmitButton
                            className="w-100 mt-5"
                            type="submit"
                            color={props.row ? "primary" : "success"}
                            icon={props.row ? faEdit : faPlus}
                            wrapperClassName="w-100"
                            loading={isLoading}
                            disabled={
                                isLoading ||
                                (selectedOption?.label.length === 0 &&
                                    selectedOption?.value === 0)
                            }
                            loadingSize={"sm"}
                        >
                            {props.row ? "Editar" : "Salvar"}
                        </UnForm.SubmitButton>
                    </div>
                </div>
            </UnForm>
        </OrSpinner>
    );
}
